import { z } from 'zod';
import { BiasTask } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-bias-task';
import { MetricDefinitionCalibrationFraming } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-calibration-framing';
import { NumericDisplayUnit } from 'libs/end-to-end/src/metrics';

export const MetricDefinitionWhiteLabeling = z
  .object({
    subjectSingular: z.string(),
    subjectPlural: z.string(),
    subjectPassiveVerb: z.string(),
    subjectConditionalVerb: z.string().optional(),
    proceseesDescription: z.string(),
    eventDisplayName: z.string().optional(),
  })
  .describe('MetricDefinitionWhiteLabeling');

export type MetricDefinitionWhiteLabeling = z.infer<
  typeof MetricDefinitionWhiteLabeling
>;

export const MetricDefinition = z
  .object({
    columnHeaderValue: z.string(),
    displayName: z.string(),
    isPreferred: z.boolean(),
    calibrationFraming: MetricDefinitionCalibrationFraming.optional(),
    skillFraming: MetricDefinitionCalibrationFraming.optional(),
    whiteLabeling: MetricDefinitionWhiteLabeling.optional(),
    biasTasks: z.array(BiasTask).nullish(),
    performanceMetric: z.string().nullish(),
    description: z.string().optional(),
    unit: NumericDisplayUnit.optional(),
  })
  .describe('MetricDefinition');

export type MetricDefinition = z.infer<typeof MetricDefinition>;
